import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ScanService {

  token: any ;
  httpOptions: any;

  constructor(@Inject('API_URL') private apiUrl: string, private httpClient: HttpClient) {
    this.token = sessionStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.token
      })
    };
  }

  dep: string;

  async get_one_scan(dep: string, d:string, level:string, sup: string){
    const _url = `${this.apiUrl}/api/scanreport/one`;
    return this.httpClient.post(_url, {dep:dep, d: d, level: level, sup: sup }, this.httpOptions).toPromise();
    console.log(d);
  }
  async getSummaryByOne(id: string, d:string){
    const _url = `${this.apiUrl}/api/scan/getSummaryByOne`;
    return this.httpClient.post(_url, {id:id, d: d }, this.httpOptions).toPromise();
  }


}
